import { checkIsJordanDropsHost, JORDAN_DROPS_HOSTNAME } from '@nike/privacy-shared-logic';
import { SUBDOMAIN_HOST_NAME } from '../constants';
export const resolveConsentCookieDomain = () => checkIsJordanDropsHost() ? `.${JORDAN_DROPS_HOSTNAME}` : SUBDOMAIN_HOST_NAME;
export const getConsentCookieRemovalAttributes = () => {
    const hostname = window.location.hostname;
    return [
        { path: '/' },
        ...(hostname ? [{ path: '/', domain: hostname }] : []),
        { path: '/', domain: resolveConsentCookieDomain() },
    ];
};
